import * as React from 'react';
import {
  UseCurrentRefinementsProps,
  useCurrentRefinements
} from 'react-instantsearch';

import { useSearchListContext } from '../context/SearchListProvider';

export type CurrentRefinementsProps = UseCurrentRefinementsProps;

const CurrentRefinements = ({ ...props }: CurrentRefinementsProps) => {
  const { facets } = useSearchListContext();

  const transformItems = React.useCallback<
    NonNullable<CurrentRefinementsProps['transformItems']>
  >(
    (items) =>
      items.map((item) => ({
        ...item,
        label: item.label,
        refinements: item.refinements.map((refinement) => {
          let { label } = refinement;

          return {
            ...refinement,
            label
          };
        })
      })),
    [facets]
  );

  const { items, refine } = useCurrentRefinements({
    transformItems,
    ...props
  });

  return items.length > 0 ? (
    <div className="search-list__current-filters">
      {items.map((item) =>
        item.refinements.map((refinement) => (
          <button
            key={item.label + refinement.label}
            type="button"
            aria-selected="true"
            className="tag typo-tag font-uppercase"
            onClick={() => refine(refinement)}
          >
            <span>{refinement.label}</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M8.70703 8L13.3535 12.6465L12.6464 13.3536L7.99992 8.70711L3.35344 13.3536L2.64633 12.6465L7.29282 8L2.64641 3.35359L3.35351 2.64648L7.99992 7.29289L12.6463 2.64648L13.3534 3.35359L8.70703 8Z"
                fill="#78766A"
                stroke="#78766A"
                stroke-width="0.3"
              />
            </svg>
          </button>
        ))
      )}
    </div>
  ) : null;
};

export default CurrentRefinements;
